import "./_guide-calculator-styles.scss";

var $ = jQuery.noConflict();

$(document).ready(function () {
    const L10n = typeof guideCalculatorL10n !== 'undefined' ? guideCalculatorL10n : {};
    const thousandsSep = L10n.thousandsSep || ' ';
    const decimalSep = L10n.decimalSep || ',';
    const fallbackCurrency = L10n.currency || 'SEK';

    /**
     * Push GA4 add_to_cart for guide calculator rows (AJAX add — not caught by GTM4WP click handlers).
     */
    function pushGuideCalculatorAddToCartDataLayer($form) {
        const items = [];
        let sumValue = 0;

        $form.find('.guide-calculator__product-row').each(function() {
            const $row = $(this);
            if (!$row.find('.guide-calculator-select-row').is(':checked')) {
                return;
            }
            const qty = parseFloat($row.find('.guide-calculator-quantity-input').val()) || 0;
            if (qty <= 0) {
                return;
            }
            const raw = $row.find('.guide-calculator-gtm-productdata').attr('data-gtm4wp_product_data');
            if (!raw) {
                return;
            }
            let productdata;
            try {
                productdata = JSON.parse(raw);
            } catch (e) {
                return;
            }
            if (productdata.productlink) {
                delete productdata.productlink;
            }
            productdata.quantity = qty;
            const price = typeof productdata.price === 'string' ? parseFloat(productdata.price) : productdata.price;
            if (!isNaN(price)) {
                productdata.price = price;
                sumValue += price * qty;
            }
            items.push(productdata);
        });

        if (!items.length) {
            return;
        }

        const currency = typeof gtm4wp_currency !== 'undefined' ? gtm4wp_currency : fallbackCurrency;
        const ecommerceValue = parseFloat(sumValue.toFixed(2));

        if (typeof gtm4wp_push_ecommerce === 'function') {
            gtm4wp_push_ecommerce('add_to_cart', items, {
                currency: currency,
                value: ecommerceValue
            });
            return;
        }

        const dlName = typeof gtm4wp_datalayer_name !== 'undefined' ? gtm4wp_datalayer_name : 'dataLayer';
        window[dlName] = window[dlName] || [];
        if (typeof gtm4wp_clear_ecommerce !== 'undefined' && gtm4wp_clear_ecommerce) {
            window[dlName].push({ ecommerce: null });
        }
        window[dlName].push({
            event: 'add_to_cart',
            ecommerce: {
                currency: currency,
                value: ecommerceValue,
                items: items
            }
        });
    }

    function parseAreaValue(str) {
        if (!str || typeof str !== 'string') return 0;
        const cleaned = str.replace(/\s/g, '').replace(new RegExp('\\' + thousandsSep, 'g'), '').replace(decimalSep, '.');
        return parseFloat(cleaned) || 0;
    }

    function formatAreaValue(num) {
        if (num === 0 || isNaN(num)) return '';
        const parts = num.toFixed(2).split('.');
        const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
        const decPart = parts[1];
        return decPart && parseInt(decPart, 10) > 0 ? intPart + decimalSep + decPart : intPart;
    }

    function sanitizeAreaInput(val) {
        let s = (val || '').replace(/\s/g, '').replace(',', '.');
        const dotIdx = s.indexOf('.');
        if (dotIdx >= 0) {
            const before = s.slice(0, dotIdx).replace(/\D/g, '');
            const after = s.slice(dotIdx + 1).replace(/\D/g, '').slice(0, 2);
            s = before.slice(0, 10) + (after.length ? '.' + after : '');
        } else {
            s = s.replace(/\D/g, '').slice(0, 10);
        }
        return s;
    }

    // Set input value with formatted number and restore cursor after the same number of digits
    function setFormattedWithCursor($input, formatted) {
        const el = $input[0];
        if (!el) return;
        const start = el.selectionStart;
        const oldVal = el.value;
        const digitsBeforeCursor = (oldVal.slice(0, start).match(/\d/g) || []).length;

        $input.val(formatted);

        let newPos = formatted.length;
        let digits = 0;
        for (let i = 0; i < formatted.length; i++) {
            if (/\d/.test(formatted[i])) {
                digits++;
                if (digits > digitsBeforeCursor) break;
            }
            newPos = i + 1;
        }
        el.setSelectionRange(newPos, newPos);
    }

    function parseThicknessCm(str) {
        if (!str || typeof str !== 'string') return 0;
        const cleaned = str.replace(/\s/g, '').replace(new RegExp('\\' + thousandsSep, 'g'), '').replace(decimalSep, '.');
        return parseFloat(cleaned) || 0;
    }

    function formatThicknessCm(num) {
        if (num === 0 || isNaN(num)) return '';
        const parts = num.toFixed(2).split('.');
        const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
        const decPart = parts[1];
        return decPart && parseInt(decPart, 10) > 0 ? intPart + decimalSep + decPart : intPart;
    }

    // If user already has valid zip (e.g. from product page), don't ask again (works even when page is cached)
    function isZipVerifiedViaCookies() {
        function getCookie(name) {
            const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)'));
            return m ? decodeURIComponent(m[1]) : '';
        }
        const zip = getCookie('nccdeliveryzip');
        const quarry = getCookie('nccquarrydata');
        const pricing = getCookie('nccquarrypricing');
        if (!zip || !quarry || !pricing) return false;
        try {
            const data = JSON.parse(atob(quarry));
            if (data && data.distance === 999) return false; // unreachable
            return true;
        } catch (e) {
            return false;
        }
    }

    // Guide calculator functionality
    $('.guide-calculator-form').each(function() {
        const $form = $(this);
        const $areaInput = $form.find('.guide-calculator-area');
        const $productRows = $form.find('.guide-calculator__product-row');
        const $submitBtn = $form.find('.add-guide-calculator-to-cart[type="submit"]');
        const $zipTriggerBtn = $form.find('.js-zip-trigger');

        // If zip already set elsewhere (cookies), show verified state so we don't ask again
        const $zipWrapper = $form.find('.block-guide-calculator__buttons').parent();
        if ($zipWrapper.length && $zipWrapper.hasClass('js-zip-unverified') && isZipVerifiedViaCookies()) {
            $zipWrapper.removeClass('js-zip-unverified').addClass('js-zip-verified');
        }

        function updateSubmitButtonState() {
            const area = parseAreaValue($areaInput.val());
            const hasSelection = $form.find('.guide-calculator-select-row:checked').length > 0;
            const disabled = area <= 0 || !hasSelection;
            $submitBtn.prop('disabled', disabled);
            $zipTriggerBtn.prop('disabled', disabled);
        }
        updateSubmitButtonState();

        // Calculate function (thickness input is in cm; convert to m for formula)
        // Display: actual weight. Cart: round up to nearest step (e.g. 0.5 ton).
        function formatWeight(num) {
            if (num === 0 || isNaN(num)) return '-';
            const parts = num.toFixed(2).split('.');
            const intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSep);
            const decPart = parts[1];
            return (decPart && parseInt(decPart, 10) > 0 ? intPart + decimalSep + decPart : intPart);
        }

        function calculateQuantity($row, area) {
            const thicknessCm = parseThicknessCm($row.find('.guide-calculator-thickness').val());
            const thicknessM = thicknessCm / 100;
            const density = parseFloat($row.data('density')) || 0;
            const step = parseFloat($row.find('.guide-calculator__quantity-value').data('step')) || 0.5;

            if (area > 0 && thicknessM > 0 && density > 0) {
                // Actual weight: area (m²) × thickness (m) × density
                const actualWeight = area * thicknessM * density;
                // Round up to nearest step for cart (e.g. nearest 0.5 ton), minimum 1
                const cartQuantity = Math.max(1, Math.ceil(actualWeight * (1 / step)) * step);

                $row.find('.guide-calculator__quantity-value').text(formatWeight(actualWeight));
                $row.find('.guide-calculator-quantity-input').val(cartQuantity);
            } else {
                $row.find('.guide-calculator__quantity-value').text('-');
                $row.find('.guide-calculator-quantity-input').val(0);
            }
        }

        // Area: block spaces, limit digits, format with thousands separator while typing
        $areaInput.on('keydown', function(e) {
            if (e.key === ' ' || e.key === 'Space') e.preventDefault();
        });
        $areaInput.on('input', function() {
            const $el = $(this);
            const raw = $el.val();
            const sanitized = sanitizeAreaInput(raw);
            const area = parseAreaValue(sanitized);
            if (area > 0) {
                setFormattedWithCursor($el, formatAreaValue(area));
            } else if (sanitized !== raw) {
                $el.val(sanitized);
            }
            if (area > 0) $form.find('.guide-calculator__area-error').removeClass('active').text('');
            updateSubmitButtonState();
            $productRows.each(function() { calculateQuantity($(this), area); });
        });
        $areaInput.on('blur', function() {
            const area = parseAreaValue($(this).val());
            if (area > 0) $(this).val(formatAreaValue(area));
        });
        $areaInput.on('focus', function() {
            const area = parseAreaValue($(this).val());
            if (area > 0) $(this).val(area.toString().replace('.', decimalSep));
        });

        // Thickness (cm): format with thousands separator while typing, parse on focus
        $form.find('.guide-calculator-thickness').on('blur', function() {
            const val = parseThicknessCm($(this).val());
            if (val > 0) $(this).val(formatThicknessCm(val));
        });
        $form.find('.guide-calculator-thickness').on('focus', function() {
            const val = parseThicknessCm($(this).val());
            if (val > 0) $(this).val(val.toString().replace('.', decimalSep));
        });
        $form.find('.guide-calculator-thickness').on('input change', function() {
            const $el = $(this);
            const val = parseThicknessCm($el.val());
            if (val > 0) {
                setFormattedWithCursor($el, formatThicknessCm(val));
            }
            const $row = $el.closest('.guide-calculator__product-row');
            const area = parseAreaValue($areaInput.val());
            calculateQuantity($row, area);
        });

        // Track which products are already in cart (populated when server returns warning)
        let inCartProducts = [];

        function updateNotification() {
            const $notification = $form.find('.guide-calculator-notification');
            if (!$notification.hasClass('active') || inCartProducts.length === 0) return;

            const checkedIds = [];
            $form.find('.guide-calculator__product-row').each(function() {
                const $row = $(this);
                if ($row.find('.guide-calculator-select-row').is(':checked')) {
                    checkedIds.push(parseInt($row.find('input[name="guide_calculator_products[]"]').val(), 10));
                }
            });

            const stillInCart = inCartProducts.filter(p => checkedIds.indexOf(p.id) !== -1);
            const $forceBtn = $notification.find('.add-guide-calculator-to-cart[data-force="true"]');

            if (stillInCart.length === 0) {
                $notification.removeClass('active');
                inCartProducts = [];
                return;
            }

            const introText = (typeof guideCalculatorL10n !== 'undefined' && guideCalculatorL10n.alreadyInCart)
                ? guideCalculatorL10n.alreadyInCart
                : 'Du har redan följande sparade produkter:';
            const outroText = (typeof guideCalculatorL10n !== 'undefined' && guideCalculatorL10n.doubleCheck)
                ? guideCalculatorL10n.doubleCheck
                : 'Vänligen dubbelkolla att du beställer rätt mängd material.';
            const names = stillInCart.map(p => p.name).join(', ');
            $notification.find('.guide-calculator-notification__content').html(
                '<p>' + introText + '</p><p><strong>' + names + '.</strong></p><p>' + outroText + '</p>'
            );

            const hasChecked = checkedIds.length > 0;
            $forceBtn.prop('disabled', !hasChecked);
        }

        // When row selection changes, update button state and notification
        $form.find('.guide-calculator-select-row').on('change', function() {
            updateSubmitButtonState();
            updateNotification();
        });

        // Add to cart handler - works for both main button and popup button
        $form.closest('.block-guide-calculator').on('click', '.add-guide-calculator-to-cart', function(e) {
            e.preventDefault();

            const $button = $(this);
            let guide_products = [];
            let guide_quantities = [];

            // Collect all rows in order (same as original); unchecked rows get quantity 0
            $form.find('.guide-calculator__product-row').each(function() {
                const $row = $(this);
                const productId = $row.find('input[name="guide_calculator_products[]"]').val();
                const isChecked = $row.find('.guide-calculator-select-row').is(':checked');
                const quantity = isChecked ? (parseFloat($row.find('.guide-calculator-quantity-input').val()) || 0) : 0;
                guide_products.push(productId);
                guide_quantities.push(quantity > 0 ? quantity : 0);
            });

            // Validate that we have products with quantities > 0 (only for first click, not force)
            const forceAdd = $button.attr('data-force') === 'true';
            if (!forceAdd) {
                const area = parseAreaValue($areaInput.val());
                const hasValidProducts = guide_quantities.some(qty => qty > 0);

                if (area <= 0) {
                    $areaInput.focus();
                    const $errorContainer = $form.find('.guide-calculator__area-error');
                    const errorMessage = (typeof guideCalculatorL10n !== 'undefined' && guideCalculatorL10n.areaRequired)
                        ? guideCalculatorL10n.areaRequired
                        : 'Vänligen ange area för att beräkna mängder.';
                    $errorContainer.text(errorMessage).addClass('active');
                    return;
                }

                if (!hasValidProducts) {
                    $areaInput.focus();
                    const $errorContainer = $form.find('.guide-calculator__area-error');
                    const errorMessage = (typeof guideCalculatorL10n !== 'undefined' && guideCalculatorL10n.areaRequired)
                        ? guideCalculatorL10n.areaRequired
                        : 'Vänligen ange area för att beräkna mängder.';
                    $errorContainer.text(errorMessage).addClass('active');
                    return;
                }
            }

            // Clear any validation errors
            $form.find('.guide-calculator__area-error').removeClass('active').text('');

            // Check if zip code is valid (using Pricing.isValidPostalCode() from global JS)
            if (typeof Pricing !== 'undefined' && !Pricing.isValidPostalCode()) {
                $('.js-zip-modal').addClass('js-open');
                const modal = document.getElementsByClassName("js-zip-modal")[0];
                if (modal) {
                    modal.focus();
                }
                return;
            }

            // Must have at least one product with quantity > 0
            const hasValidProducts = guide_quantities.some(function(q) { return q > 0; });
            if (!hasValidProducts) {
                $form.find('.guide-calculator__area-error').text(
                    (typeof guideCalculatorL10n !== 'undefined' && guideCalculatorL10n.areaRequired) ? guideCalculatorL10n.areaRequired : 'Vänligen ange area för att beräkna mängder.'
                ).addClass('active');
                return;
            }

            // Hide notification before new request
            $form.find('.guide-calculator-notification').removeClass('active');

            const ajaxUrl = typeof wp_ajax !== 'undefined' && wp_ajax.url ? wp_ajax.url : (typeof ajaxurl !== 'undefined' ? ajaxurl : '/wp-admin/admin-ajax.php');

            function setAddToCartButtonsDisabled(disabled) {
                $form.closest('.block-guide-calculator').find('.add-guide-calculator-to-cart, .js-zip-trigger').prop('disabled', disabled);
            }

            function sendAddToCart(nonce) {
                setAddToCartButtonsDisabled(true);

                const postData = {
                    action: 'add_guide_calculator_to_cart',
                    security: nonce,
                    force: $button.attr('data-force'),
                    clear: $button.attr('data-clear'),
                    guide_calculator_addtocart: 'true'
                };
                guide_products.forEach(function(id, i) {
                    postData['guide_calculator_products[' + i + ']'] = id;
                });
                guide_quantities.forEach(function(qty, i) {
                    postData['guide_calculator_quantities[' + i + ']'] = qty;
                });

                $.ajax({
                    url: ajaxUrl,
                    dataType: 'json',
                    type: 'POST',
                    data: postData,
                    success: function (response) {
                        if (response && response.success) {
                            pushGuideCalculatorAddToCartDataLayer($form);
                            if (response.redirect && response.redirect.length) {
                                window.location.href = response.redirect;
                            }
                        } else {
                            setAddToCartButtonsDisabled(false);
                            const $notification = $form.find('.guide-calculator-notification');
                            const msg = (response && response.output) ? response.output : (
                                (typeof guideCalculatorL10n !== 'undefined' && guideCalculatorL10n.errorOccurred)
                                    ? guideCalculatorL10n.errorOccurred
                                    : 'Ett fel uppstod. Försök igen.'
                            );
                            $notification.find('.guide-calculator-notification__content').html(typeof msg === 'string' ? msg : '');
                            $notification.addClass('active');

                            if (response && response.in_cart_products && response.in_cart_products.length) {
                                inCartProducts = response.in_cart_products;
                            } else {
                                inCartProducts = [];
                            }
                        }
                    },
                    error: function () {
                        setAddToCartButtonsDisabled(false);
                        const errorMessage = (typeof guideCalculatorL10n !== 'undefined' && guideCalculatorL10n.errorOccurred)
                            ? guideCalculatorL10n.errorOccurred
                            : 'Ett fel uppstod. Försök igen.';
                        alert(errorMessage);
                    }
                });
            }

            $.getJSON(ajaxUrl + (ajaxUrl.indexOf('?') >= 0 ? '&' : '?') + 'action=guide_calculator_get_nonce')
                .done(function(res) {
                    if (res && res.nonce) {
                        sendAddToCart(res.nonce);
                    } else {
                        sendAddToCart($form.find('[name="add-guide-calculator-to-cart-nonce"]').val());
                    }
                })
                .fail(function() {
                    sendAddToCart($form.find('[name="add-guide-calculator-to-cart-nonce"]').val());
                });
        });

        $form.closest('.block-guide-calculator').on('click', '.js-zip-trigger', function(e) {
            e.preventDefault();
        });
    });

    function updateScrollShadowClasses() {
        $('.guide-calculator__products-wrapper').each(function() {
            const el = this;
            const canScrollLeft = el.scrollLeft > 0;
            const canScrollRight = el.scrollLeft < el.scrollWidth - el.clientWidth - 1;
            $(el).toggleClass('can-scroll-left', canScrollLeft);
            $(el).toggleClass('can-scroll-right', canScrollRight);
        });
    }
    $('.guide-calculator__products-wrapper').on('scroll', updateScrollShadowClasses);
    $(window).on('resize', updateScrollShadowClasses);
    updateScrollShadowClasses();
});
